var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider",on:{"click":_vm.click}},[_c('div',{staticClass:"slider__line",attrs:{"id":_vm.sliderId}}),_vm._v(" "),_c('div',{staticClass:"slider__progress",style:(_vm.sliderPosition),on:{"dragstart":_vm.dragStart,"mousedown":_vm.mouseDown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }